<template>
  <View preview-mode class="slot-picker-container">
    <Transition name="fade" appear>
      <Card>
        <header>Choose a physician</header>
        <SlotPickerPhysicianSelect tabindex="1" @update-selected="onPhysicianSelect" />

        <template v-if="selectedPhysician">
          <header>Choose a visit type</header>
          <SlotPickerVisitTypeSelect
            tabindex="2"
            :physician-id="selectedPhysician"
            @update-selected="onVisitTypeSelect"
          />
        </template>

        <sp-expandable-area size="27" title="Advanced" color="var(--sp-dtv-toggle-activator-color, #007078)">
          <header>Enter an appointment slot ID</header>
          <BaseTextField v-model="slotId" />
          <div>or leave blank to continue without an explicit slot</div>
        </sp-expandable-area>

        <template #actions-end>
          <sp-button color="primary" :size="size" @click="onSlotSelect" :disabled="!slotId">Continue</sp-button>
        </template>
      </Card>
    </Transition>
  </View>
</template>

<script setup>
import { onMounted, ref } from "vue";
import Card from "./Card.vue";
import SlotPickerPhysicianSelect from "./SlotPickerPhysicianSelect.vue";
import SlotPickerVisitTypeSelect from "./SlotPickerVisitTypeSelect.vue";
import View from "./View.vue";

const emit = defineEmits(["select"]);

const selectedPhysician = ref(null);
const slotId = ref(null);

function onPhysicianSelect(id) {
  selectedPhysician.value = id;
}

function onVisitTypeSelect(visitType) {
  slotId.value = visitType?.slotId;
}

function onSlotSelect() {
  emit("select", slotId.value);
}

const size = ref("default");
function setSize() {
  const cpSize = getComputedStyle(document.documentElement).getPropertyValue("--sp-dtv-card-action-size");
  const validatorSizes = ["small", "medium", "large", "default"];

  if (validatorSizes.includes(cpSize)) {
    size.value = cpSize;
  }
}

onMounted(() => {
  setSize();
});
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.slot-picker-container {
  sp-expandable-area,
  &:deep(.card__content > * + *) {
    margin-top: 1rem;
  }

  header {
    font-weight: var(--sp-dtv-card-header-font-weight, 700);
    font-size: var(--sp-dtv-card-header-font-weight, 1.125rem);
  }
}
</style>
